import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';

// TODO: Should I make this a standalone package (packages/issue-archival/use-archive-issue-url)?
export const useArchiveIssueUrl = (): string => {
	// TODO: Check if this is the correct way to get the project context and will always be available, it shouldn't be behind any feature flag
	const { data: projectContext } = useProjectContext();
	const { projectType, simplified, projectKey } = projectContext || {};

	switch (projectType) {
		case SOFTWARE_PROJECT: {
			if (simplified) {
				return `/jira/software/projects/${projectKey}/archived-work-items`;
			}
			return `/jira/software/c/projects/${projectKey}/archived-work-items`;
		}
		case SERVICE_DESK_PROJECT: {
			return `/jira/servicedesk/projects/${projectKey}/archived-work-items`;
		}
		case CORE_PROJECT: {
			return `/jira/core/projects/${projectKey}/archived-work-items`;
		}
		case PRODUCT_DISCOVERY_PROJECT: {
			return `/jira/product-discovery/projects/${projectKey}/issues/archive`;
		}
		default: {
			// TODO: Throw an error
			return '/jira/issues/archive';
		}
	}
};
